import OpticksLink from "@/components/ui/OpticksLink/OpticksLink";
import OpticksNumberCircle from "@/components/ui/OpticksNumberCircle/OpticksNumberCircle";

interface Props {
  stepLabel?: string;
}

const TaboolaIntegrationStep1 = ({ stepLabel }: Props) => (
  <div className="channels-integration-step taboola-step-1">
    <div className="step-label-row">
      {stepLabel && <OpticksNumberCircle number={stepLabel} />}
      <h6>Taboola Pixel installation</h6>
    </div>
    <div className="wrapper">
      <p>
        The{" "}
        <OpticksLink
          href="https://www.taboola.com/help/en/articles/10442298-audience-exclusion-for-already-converted-users"
          label="Taboola Pixel"
        />{" "}
        is the piece of code that allows Taboola to track conversions and build
        Audiences. It is required for the audience exclusion feature to work.
      </p>
      <p>
        Opticks uses these Audiences to exclude invalid traffic from your
        campaigns. The first step is to make sure that both the{" "}
        <b>Opticks script</b> and your <b>Taboola Pixel</b> are properly
        installed on the same page you want to protect.
      </p>
      <p>
        Go to your{" "}
        <OpticksLink
          href="https://ads.taboola.com"
          label="Taboola Ads dashboard"
        />
        , create or locate your pixel, and add it to your website. Once both
        scripts are in place, Opticks will be able to detect fraudulent visitors
        and signal Taboola to exclude them.
      </p>
    </div>
  </div>
);

export default TaboolaIntegrationStep1;
